<template>
<div class="content-wrap">
    <h1 tabindex="-1" v-if="menuParent" v-html="languageData['d'+menuParent]" class="sr-only"></h1>
    <template v-for="(submenu, keiy) in menuItems">
            
        <template v-if="keiy.trim()==menuParent">
            <ul :key="keiy"> 
                <li v-for="(subitems, keiyi) in submenu" :key="keiyi">
                    <article class="blog-entry-travel animate-box">
                        <!--<div class="blog-img" style="background-image: url('"+CONTENT_DOMAIN+"/img/modules/"+subitems+".jpg');"></div>-->
                        <div class="blog-img" :style="'background-image: url('+CONTENT_DOMAIN+moduleImage[subitems]+subitems+'.jpg)'"></div>
                        <div class="desc">
                            <p class="meta">
                                <span class="cat">
                                <h2> <router-link :to="'/module/'+subitems+'/division/'+menuParent" v-html="languageData['m'+subitems]"></router-link>
                                    </h2><!--<a href="">{{languageData['m'+subitems]}}</a>-->
                                </span>											
                            </p>
                        </div>
                    </article>
                </li>
            </ul>
        </template> 
        
    </template>
    
</div>
</template>
<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
  
  export default {
    name: 'DivisionTiles',
   /* props:['parentMenuId','iCount','subMenu'],*/
	data() {           
        return {          
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            //menuParent:this.parentMenuId,            
            menuParent:this.$route.params.division_id
            //subMenus:[]         
        }
    },    
    components: {
     },
    watch: { 
        // call again the method if the route changes
        '$route': 'showContent'        
        
    },
    computed:{        
            menuItems(){return this.$store.state.menuVar;},
            moduleImage(){ return this.$store.state.moduleImage;},
            languageData() {

                var titleValue =this.decodeHtmlLang(this.$store.state.languageData['d'+this.$route.params.division_id]);                
                //var home = this.decodeHtmlLang(this.$store.state.languageData['d00'])
                //document.title = home+' | '+titleValue+' | '+this.$store.state.companyData['name_company'];
                document.title = titleValue+' | '+this.$store.state.companyData['name_company'];
                return this.$store.state.languageData;
            }  
           // subMenus(){return this.menuItems[this.menuParent]}
        },
    mounted :function(){
        this.showFocus();
		},
	methods:{
        showContent(){
            //this.menuParent : this.$route.params.division_id
            this.menuParent =this.$route.params.division_id;
            this.web_hits();
            this.showFocus();
        },
        showFocus(){                                        
            var heading = document.querySelector('h1');
            heading.focus();
        } 

    }
  }
</script>

<style scoped>
.blog-entry-travel .desc {
    width: 0%;
    padding: 5em 0em 6em 0em;
    margin: 0;
    background: #fafafa;
    
}
article .desc .meta span {
    
    margin-bottom: 0 !important;
}
article {
    width: 334px;
    float: left;
    margin-bottom: 2em;
    /* float: left; */
    margin-right: 2em;
}
.blog-entry-travel .blog-img {
    width: inherit !important;
}

.blog-entry-travel .desc .meta {    
    top: 0px;
    width: 334px;
    background: #1f1f1fa8;
    right: 0;
    min-width: 165px;
}
.blog-entry-travel .desc .meta:hover, .blog-entry-travel .desc .meta:focus{
    background: #2f2f2fcc;
}
article .desc .meta {
    left: auto;
    text-align: center;
}
.blog-entry-travel .desc .meta span a {
    color: #ffffffeb;
    
}
.blog-entry-travel .desc .meta span a:hover {
    color: #ffffff;
}

@media screen and (max-width: 768px){
    .blog-entry-travel .desc .meta {
        top: 0px !important;
        position: absolute !important;
        text-align: right;
    }
    article .desc .meta{
        text-align: center !important;
    }
    article {
        width: 320px;
        margin-right: 10px;
    }
    .blog-entry-travel .desc .meta{
        width: 320px;
    }
   
}
@media screen and (max-width: 480px){
    article {
        width: 95%;
    }
    .blog-entry-travel .desc .meta{
        width: 95%;
    }
}

.content-wrap {
    padding-right: 1px;
}
h2{
    margin: 0px !important;
    font-size: 13px !important;
    padding: 3px 0 !important;
}
.content-wrap ul{
    margin: 0;
    padding: 0;
}
.content-wrap li{
    list-style:none;
}
</style>
